<template>
    <div class="optpl-template-item optpl-template-item__pack">
        <span :class="'optpl-template-item__mark optpl-template-item__tag optpl-template-item__tag-' + item.mark" v-if="item.mark">{{ item.mark.toUpperCase() }}</span>
        <figure :style="'background-image: url(' + this.image + ')'"><img :src="this.image" alt="" @click="this.$router.push({ name: 'pack', params: { uid: item.uid }})"></figure>

        <div class="optpl-template-item__text">
            <h4>
                <span>{{ item.title ? item.title : 'Some Title' }}</span>
                <span class="optpl-template-item__price" v-if="item.amount ">${{ item.amount / 100 }}</span>
            </h4>
            <div class="optpl-template-item__description">{{ item.description_text ? item.description_text : item.description }}</div>

            <div class="optpl-template-item__overlay optpl-template-item__overlay-pack">
                <router-link :to="{ name: 'pack', params: { uid: item.uid }}" class="opui-btn opui-btn-secondary">
                    {{ $e('View Pack') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: { type: Object, required: true },
    },
    computed: {
        image() {
            let image = ''

            if (this.item.preview) image = this.item.preview
            if (this.item.preview_full) image = this.item.preview_full

            return image
        }
    },
}
</script>
